export class TempFileServiceError extends Error {}
